import React from "react";

export default function useControllableState<T>(
  valueProp: T | undefined,
  setValueProp: React.Dispatch<React.SetStateAction<T>> | undefined,
  defaultValue: T | undefined,
) {
  if (valueProp === undefined && defaultValue === undefined)
    throw new Error("Must use either value or default value");
  if (
    (valueProp === undefined && setValueProp !== undefined) ||
    (valueProp !== undefined && setValueProp === undefined)
  )
    throw new Error("Must use either controlled or uncontrolled");

  const [valueState, setValueState] = React.useState(defaultValue);
  const value = valueProp === undefined ? (valueState as T) : valueProp;
  const setValue = setValueProp || (setValueState as React.Dispatch<React.SetStateAction<T>>);

  return [value, setValue] as const;
}
